import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { nowBasicCheckResponseAccessorIsCurrentVariantEligibleForDelivery } from '../../../../now'
import { useProductPageContext } from '../../productPageContext'

export const ProductBuyBoxNowDeliveryInfo: FC = () => {
  const { nowDetails } = useProductPageContext()

  return (
    <div className="flex flex-col">
      <span>
        <FormattedMessage id="message.soldAndShipped.partnerCrossSell" />
      </span>
      <span className="text-l font-medium">
        {nowBasicCheckResponseAccessorIsCurrentVariantEligibleForDelivery(
          nowDetails.nowDataPerProductCurrentVariantResponse,
        ) ? (
          <FormattedMessage id="now.delivery.shopWithNow" />
        ) : (
          <FormattedMessage id="now.delivery.shop" />
        )}
      </span>
    </div>
  )
}
